import React, { useEffect, useState } from "react"
import Header from './components/Header';
import Main from './components/Main';
import Footer from './components/Footer';
import ThemeToggle from './components/ThemeToggle';

function App() {
  const [websiteVisits, setWebsiteVisits] = useState(0)
  const API_URL = 'https://u53ey3bptczae2t2fgif4lq6vq0qeqvv.lambda-url.us-west-2.on.aws/'

  useEffect(() => {
    const fetchWebSiteVisits = async () => {
      try {
        const response = await fetch(API_URL)
        const count = await response.json()
        setWebsiteVisits(count)
      } catch (e) {}
    }
    fetchWebSiteVisits()
  }, [])

  return (
    <>
      <ThemeToggle />
      <Header />
      <Main />
      <Footer visits={websiteVisits} />
    </>
  )
}

export default App;
